import "./scoreTable.scss";
import { useEffect, useState } from "react";
import coffeeTools from "../../CoffeeTools";

const ScoreTable: React.FC<{
  scores: {
    team_logo;
    team_color;
    team_name;
    jj;
    jg;
    jp;
    pf;
    pc;
    dif;
    p;
  };
}> = ({ scores }) => {
  //   const [showProgessBar, setShowProgessBar] = useState(true);
  let base_url = process.env.REACT_APP_BASE_URL;
  let coffee_tools = new coffeeTools();

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    let coffee = new coffeeTools();
    // console.log(coffee.test(123));
  }, []);

  var controller = (() => {
    return {};
  })();

  let view = (() => {
    let dom_obj = {};

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    return {
      createSectionTitles: (title, container) =>
        createSectionTitles(title, container)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("score table component started");
        setupEventListeners();
      }
    };
  })(controller, view);

  return (
    <div
      style={{
        display: "flex",
        marginBottom: "0.2rem",
        borderBottom: "0.01rem solid black"
      }}
    >
      <div
        style={{
          flex: 1,
          backgroundColor: scores.team_color,
          maxWidth: "3.2rem"
        }}
      >
        <img
          src={base_url + scores.team_logo}
          alt='team logo'
        />
      </div>
      <div style={{ flex: 1, alignItems: "center" }}>{scores.jj}</div>
      <div style={{ flex: 1 }}>{scores.jg}</div>
      <div style={{ flex: 1 }}>{scores.jp}</div>
      <div style={{ flex: 1 }}>{scores.pf}</div>
      <div style={{ flex: 1 }}>{scores.pc}</div>
      <div style={{ flex: 1 }}>{scores.dif}</div>
      {scores.p != null ? <div style={{ flex: 1 }}>{scores.p} </div> : ""}
    </div>
  );
};

export default ScoreTable;
